import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { common } from '../../../theme/AllocateBaseTheme';

export default function KeyboardDateSelector({
  required = false,
  disabled = false,
  errorProps,
  className = 'date-picker',
  ...rest
}) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        required={required}
        disabled={disabled}
        variant="inline"
        margin="normal"
        fullWidth
        format="dd-MM-yyyy"
        className={className}
        {...errorProps}
        KeyboardButtonProps={{ 'aria-label': 'change-date' }}
        InputLabelProps={{
          style: {
            ...common.floatingLabelStyle,
            ...common.floatingLabelShrinkStyle,
            ...common.floatingLabelFocusStyle,
            left: 0,
          },
        }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
}
